import {
  planMonthLearningMultiplier,
  resolvePlanMonthLearningRate,
} from './hillPlanMonthLearning';
import { predictRoasVectorPct } from './roasSaturation';

export { planMonthLearningMultiplier, resolvePlanMonthLearningRate };

/** @deprecated Use resolvePlanMonthLearningRate and planMonthLearningMultiplier. */
export function resolveHillRoasEfficiencyRatio(state) {
  return 1 + resolvePlanMonthLearningRate(state);
}

/** @deprecated Use planMonthLearningMultiplier. */
export function hillRoasEfficiencyMultiplier(ratio, marketingMonthIndex) {
  const rate = Math.max(0, Number(ratio) - 1);
  return planMonthLearningMultiplier(rate, marketingMonthIndex);
}

export function applyHillRoasEfficiencyRatioToVectors(vectors, learningRate) {
  if (!vectors?.length) {
    return vectors;
  }
  const rate = Math.max(0, Number(learningRate) || 0);
  if (rate === 0) {
    return vectors;
  }

  return vectors.map((vector, monthIndex) => {
    if (!vector?.length) {
      return vector;
    }
    const multiplier = planMonthLearningMultiplier(rate, monthIndex);
    return vector.map((value) => value * multiplier);
  });
}

export function buildHillSpendRoasVectors(hillModel, marketing, state) {
  if (!hillModel) {
    return null;
  }

  const baseVectors = (marketing || []).map((spend) =>
    predictRoasVectorPct(hillModel, spend)
  );

  return applyHillRoasEfficiencyRatioToVectors(
    baseVectors,
    resolvePlanMonthLearningRate(state)
  );
}
